import { render, staticRenderFns } from "./userBind_view.vue?vue&type=template&id=60bcdc68&scoped=true&"
import script from "./userBind_view.vue?vue&type=script&lang=js&"
export * from "./userBind_view.vue?vue&type=script&lang=js&"
import style0 from "./userBind_view.vue?vue&type=style&index=0&id=60bcdc68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bcdc68",
  null
  
)

export default component.exports